import { Injectable } from '@angular/core';
import { IProgramTemplateAttachmentMediaListResponse } from 'typings/api-media';
import { IServiceResponse } from 'typings/api-generic';
import { DoenKidsGenericApiProvider } from 'src/providers/generic.provider';
import { ProgramTemplateAttachmentStore } from './program-template-attachment.store';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProgramTemplateAttachmentService {
  // Even though they're not used anymore, keep the store and query imports here. Otherwise, the decorators will NOT work.
  //
  constructor(
    private store: ProgramTemplateAttachmentStore,
    private $baseApi: DoenKidsGenericApiProvider,
  ) {}

  async fetchAll({
    programTemplateId,
    limit = 100,
    skip = 0,
    sortField,
    sortDirection,
  }: {
    programTemplateId: number,
    limit?: number,
    skip?: number,
    sortField?: string,
    sortDirection?: string,
  }) {
    const response = await firstValueFrom(this.$baseApi.genericListCall('/media/program-template/attachment', limit, skip, sortField, sortDirection,
      { programTemplateId })) as IProgramTemplateAttachmentMediaListResponse;
    this.store.set(response?.items ?? []);
    return response?.items ?? [];
  }

  async fetchAttachmentsWithMedia({
    programTemplateId,
    limit = 100,
    skip = 0,
    sortField,
    sortDirection,
  }: {
    programTemplateId: number,
    limit?: number,
    skip?: number,
    sortField?: string,
    sortDirection?: string,
  }) {
    const response = await firstValueFrom(this.$baseApi.genericListCall(`/media/program-template/attachment/${programTemplateId}`, limit, skip, sortField, sortDirection,
    )) as IProgramTemplateAttachmentMediaListResponse;
    return response?.items ?? [];
  }

  update(programTemplateId, attachmentId, name): Promise<IServiceResponse> {
    return firstValueFrom(this.$baseApi.genericPutCall(
      `/media/program-template/attachment/${programTemplateId}/attachment/${attachmentId}?name=${name}`, {},
    )) as Promise<IServiceResponse>;
  }

  delete(programTemplateId, attachmentId): Promise<IServiceResponse> {
    return firstValueFrom(this.$baseApi.genericDeleteCall(
      `/media/program-template/attachment/${programTemplateId}/attachment/${attachmentId}`,
    )) as Promise<IServiceResponse>;
  }

  updateDisplayName(programTemplateId, attachmentId, name) {
    return firstValueFrom(this.$baseApi.genericPutCall(
      `/media/program-template/attachment/${programTemplateId}/attachment/${attachmentId}/display-name?name=${name}`, {},
    )) as Promise<IServiceResponse>;
  }
}
